// src/features/processus/routes.ts
import { lazy } from 'react';
import { Workflow } from 'lucide-react';
import { RouteConfig } from '../../types/routing.types';

const ProcessusDashboard = lazy(() => import('./components/ProcessusDashboard'));

export const processusRoutes: RouteConfig[] = [
  {
    path: '/processus/*',
    component: ProcessusDashboard,
    label: 'Processus',
    icon: Workflow,
    showInNav: true,
    navPath: '/processus',  // Path réel pour la navigation
  },
];
